const urls = {
    OLD_URL: `https://dev.janitri.in/`,
    BETA_URL: `https://beta.janitri.in/`,
    S3_URL: `https://beta.janitri.in/statics/`,
    LOCAL_URL: `http://localhost:8000/`,
    DEV_URL: `https://jfh.dev.janitri.in/`
    // DEV_URL:`http://35.168.153.227:8000/`
}

// WebSocket bases, derived from the REST bases above (https -> wss, http -> ws).
export const toWebSocketUrl = (httpUrl) =>
    httpUrl.replace(/^https:/, "wss:").replace(/^http:/, "ws:");

// TEMPORARY: BETA_WS_URL points at DEV_URL, not BETA_URL, because backend
// has only deployed the WebSocket module to dev so far. REST calls still
// go to beta as normal. Revert to toWebSocketUrl(urls.BETA_URL) once beta
// also has the module.
//
// Both /ws/cms/place/ and /ws/cms/patient/ 404 on dev as of 2026-09-25,
// over both wss:// and plain ws:// (tried as a diagnostic at backend's
// suggestion, to rule out a TLS/nginx-proxy issue) — same 404 either way,
// so it's not transport-specific. Waiting on backend to confirm/fix the
// ASGI routing. Nothing to change here until they do.
urls.BETA_WS_URL = toWebSocketUrl(urls.DEV_URL);
urls.DEV_WS_URL = toWebSocketUrl(urls.DEV_URL);
urls.LOCAL_WS_URL = toWebSocketUrl(urls.LOCAL_URL);

export default urls;